import { Button, Card, Col, Row, Tooltip } from 'antd';
import { t } from 'i18next';
import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { TicketBaggageModel } from '@/__generated';
import { BaggageType } from '@/constants';
import BooleanTag from '@/components/app/BooleanTag';

type Props = { baggages: TicketBaggageModel[] };

export default function TicketBaggageInfo({ baggages }: Props) {
  if (!baggages.length) {
    return <BooleanTag value={false} />;
  }
  return (
    <Tooltip
      showArrow={false}
      overlayInnerStyle={{ width: 350, background: 'white' }}
      title={
        <Card title={<b>{t('Info')}</b>} size="small" bordered={false}>
          <div style={{ color: '#333333' }}>
            <Row gutter={4}>
              <Col md={12}>
                <b>{t('Baggage type')}</b>
              </Col>
              <Col md={12}>
                <b>{t('Baggage Ref')}</b>
              </Col>
              {baggages.map(d => {
                return (
                  <>
                    <Col md={12}>
                      {d.baggageTypeName || BaggageType.__getValue(d.baggageType)}
                      {d.isFree ? ` (${t('ticketBaggage_Free')})` : ''}
                    </Col>
                    <Col md={12}>{d.baggageRefNo}</Col>
                  </>
                );
              })}
            </Row>
          </div>
        </Card>
      }
    >
      <Button type="link" icon={<CheckCircleFilled />} />
    </Tooltip>
  );
}
